import React from 'react';
import { isDefined } from '@nfctron/nexus-core';
import { LoaderCircleIcon } from 'lucide-react';
import dynamicIconImports from 'lucide-react/dynamicIconImports';

import { cn } from '../../utils';
import type { DynamicIconTypes as Types } from './DynamicIcon.types';

/**
 * DynamicIcon component, uses Lucide icons with dynamic imports.
 * @see https://lucide.dev/guide/packages/lucide-react
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
const IconComponent: React.FunctionComponent<Types.Props> = (props) => {
	const { name, ...rest } = props;
	const LucideIcon = React.lazy(() => {
		const iconImport = dynamicIconImports[name];
		if (!isDefined(iconImport) || typeof iconImport !== 'function') {
			/** fallback to CircleHelp icon if the requested icon is not found */
			return dynamicIconImports['circle-help']();
		}
		return iconImport();
	});

	return (
		<React.Suspense fallback={<LoaderCircleIcon className={cn('size-4 opacity-25 bg-zinc-200 rounded-full', rest.className)} />}>
			<LucideIcon {...rest} />
		</React.Suspense>
	);
};

export const DynamicIcon = React.memo(IconComponent);

DynamicIcon.displayName = 'Icon';
